import React from "react";
import { HiMiniSparkles } from "react-icons/hi2";

const HeroBanner = () => {
  return (
    <div className="relative bg-gray-50 w-full py-12">
      {/* Üst Gradient Çizgi */}
      <div className="w-[90%] max-w-7xl mx-auto h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent opacity-50"></div>

      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between py-8 relative z-10">
        {/* Başlık */}
        <h1 className="text-3xl md:text-5xl font-bold leading-tight text-black text-left">
          Süreç{" "}
          <span className="bg-gradient-to-r from-red-500 to-purple-600 text-transparent bg-clip-text">
            Nasıl
          </span>{" "}
          İlerliyor?
        </h1>

        {/* Buton */}
        <div className="mt-6 md:mt-0">
          <button className="flex items-center gap-2 bg-[#5A4AF4] hover:bg-[#4a3de0] text-white font-medium px-4 py-3 rounded-lg shadow-md transition">
            <HiMiniSparkles /> Detayları Keşfet
          </button>
        </div>
      </div>

      {/* Alt Gradient Çizgi */}
      <div className="w-[90%] max-w-7xl mx-auto h-[1px] bg-gradient-to-r from-transparent via-gray-300 to-transparent opacity-50"></div>
    </div>
  );
};

export default HeroBanner;
